import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoxArchiveDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_4723_516",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M23 20C23 22.2091 21.2091 24 19 24H5C2.79086 24 1 22.2091 1 20V8.72949C1.29446 8.90012 1.63519 9 2 9H22C22.3648 9 22.7055 8.90012 23 8.72949V20Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 20C23 22.2091 21.2091 24 19 24H5C2.79086 24 1 22.2091 1 20V8.72949C1.29446 8.90012 1.63519 9 2 9H22C22.3648 9 22.7055 8.90012 23 8.72949V20Z",
			fill: "url(#paint0_linear_4723_516)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 24V24.4V24.4V24ZM5 24V24.4V24.4V24ZM1 8.72949L1.20055 8.3834L0.6 8.03541V8.72949H1ZM22 9V9.4V9.4V9ZM23 8.72949H23.4V8.03541L22.7995 8.3834L23 8.72949ZM23 20H22.6C22.6 21.9882 20.9882 23.6 19 23.6V24V24.4C21.4301 24.4 23.4 22.4301 23.4 20H23ZM19 24V23.6H5V24V24.4H19V24ZM5 24V23.6C3.01178 23.6 1.4 21.9882 1.4 20H1H0.6C0.6 22.4301 2.56995 24.4 5 24.4V24ZM1 20H1.4V8.72949H1H0.6V20H1ZM1 8.72949L0.799454 9.07559C1.15149 9.27958 1.56097 9.4 2 9.4V9V8.6C1.7094 8.6 1.43743 8.52066 1.20055 8.3834L1 8.72949ZM2 9V9.4H22V9V8.6H2V9ZM22 9V9.4C22.439 9.4 22.8485 9.27958 23.2005 9.07559L23 8.72949L22.7995 8.3834C22.5626 8.52066 22.2906 8.6 22 8.6V9ZM23 8.72949H22.6V20H23H23.4V8.72949H23Z",
			fill: "url(#paint1_linear_4723_516)",
			mask: "url(#path-1-inside-1_4723_516)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 18.0805C4.31034 18.4943 6.58621 17.977 5.96552 18.3908C5.44907 18.7351 6.58621 18.3908 7 18.1839C7.41379 17.977 7.31034 18.5977 7.72414 18.1839C8.13793 17.7701 8.34483 18.1839 8.55172 18.1839C8.71724 18.1839 9.27586 17.8736 10 18.0805",
			stroke: "#FBBF24",
			strokeWidth: .2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .9,
			x: 10.05,
			y: 11.05,
			width: 3.9,
			height: .9,
			rx: .45,
			fill: "#532604",
			stroke: "#8D4107",
			strokeWidth: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 18H20",
			stroke: "#FBBF24",
			strokeWidth: .2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 19H20",
			stroke: "#FBBF24",
			strokeWidth: .2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 20H20",
			stroke: "#FBBF24",
			strokeWidth: .2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .2,
			y: 3.2,
			width: 23.6,
			height: 5.6,
			rx: 1.8,
			fill: "#B45309",
			stroke: "#B36205",
			strokeWidth: .4
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.5996 9.9082C22.4103 9.96763 22.2089 10 22 10H2C1.79106 10 1.58972 9.96763 1.40039 9.9082V8.9082C1.58972 8.96763 1.79106 9 2 9H22C22.2089 9 22.4103 8.96763 22.5996 8.9082V9.9082Z",
			fill: "url(#paint2_linear_4723_516)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_4723_516",
				x1: 12,
				y1: 8.06556,
				x2: 12,
				y2: 24,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D97706" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D97706",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_4723_516",
				x1: 12,
				y1: 8.06556,
				x2: 12,
				y2: 24,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#D97706",
					stopOpacity: .2
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D97706",
					stopOpacity: .12
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_4723_516",
				x1: 2.65203,
				y1: 7.62606,
				x2: 2.96226,
				y2: 11.5181,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#8D4107",
					stopOpacity: .24
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#8D4107"
				})]
			})
		] })
	]
});
export default SvgBoxArchiveDark;
